import { render, staticRenderFns } from "./AmountBadge.vue?vue&type=template&id=a9b94ab2&scoped=true&"
import script from "./AmountBadge.vue?vue&type=script&lang=js&"
export * from "./AmountBadge.vue?vue&type=script&lang=js&"
import style0 from "./AmountBadge.vue?vue&type=style&index=0&id=a9b94ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b94ab2",
  null
  
)

export default component.exports